import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Translation from '../../v2/lang/Translation';
import Spacing from '../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  fieldIcon: {
    position: 'relative',
    top: 0,
    bottom: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    height: 22,
    order: 1,
    padding: [0, Spacing.single],
  },
});

export default function FieldIcon(props) {
  const classes = useStyles(props);
  
  switch (typeof props.icon) {
    case 'string':
      return (
        <img
          className={classes.fieldIcon}
          data-test={props.iconClass ? `FieldIcon__${(props.iconClass)}` : 'FieldIcon'}
          src={props.icon}
          alt={props.altKey ? Translation.getText(props.altKey) : ''}
          onClick={props.onClick}
          aria-hidden="true"
        />
      );
    case 'object':
      return (
        <span className={classes.fieldIcon} data-test="FieldIcon">
          {props.icon}
        </span>
      );
    default:
      return null;
  }
}

FieldIcon.defaultProps = {
  altKey: '',
  iconClass: null,
  onClick() {
  },
};

FieldIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  altKey: PropTypes.string,
  iconClass: PropTypes.string,
  onClick: PropTypes.func,
};
